import {FilterObject} from "./filter.resource.provided";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'asiFilter'})
export class AsiFilterPipe implements PipeTransform {

  transform(items: Array<any>, filters: FilterObject[]) {
    let result = [];
    if ((items != null) && filters != null) {
      result = items.filter(obj => {
        let filtered = true;
        filters.forEach(filter => {
          filtered = filtered && filter.filter(obj, filter.field, filter.values)
        })
        return filtered;
      });
    }
    return result;
  }

  isFunction(functionToCheck: Function): boolean {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/utils/filter/asi.filter.pipe.ts